import { CacheClientService, CacheLocation } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { autoinject } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";
import * as Enumerable from "linq";
import { EventAggregator } from "aurelia-event-aggregator";

@autoinject
export class NavigationClientService {
    previousRouteKey: string = "previous-route";
    currentRoute: string;
    navigationTitle: string = "";
    back: (() => void) = null;

    constructor(private cacheClient: CacheClientService, private router: Router, eventAggregator: EventAggregator) {
        eventAggregator.subscribe("router:navigation:complete",
            () => {
                if (this.router && this.router.currentInstruction)
                    this.cache(this.router.currentInstruction.config.name, this.router.currentInstruction.params);
            });
    }

    navigateAndCache(route: string, params: any = null) {
        this.cache(route, params);
        const selectedRoute = Enumerable.from(this.router.routes).firstOrDefault(x => x.name == route);
        this.navigationTitle = selectedRoute.title;
        this.router.navigateToRoute(route, params);
    }

    setTitle(title: string) {
        this.navigationTitle = title;
    }

    setTitleAndBack(title: string, back: (() => void)) {
        this.navigationTitle = title;
        this.back = back;
    }

    private cache(route: string, params: any) {
        this.currentRoute = route;
        this.cacheClient.put(this.previousRouteKey, {
            routeName: route,
            params: params
        }, CacheLocation.LocalStorage);
    }

    navigateToPreviousRoute() {
        this.cacheClient.get<any>(this.previousRouteKey, CacheLocation.LocalStorage, false).then(route => {
            if (route && this.currentRoute != route.routeName) {
                this.router.navigateToRoute(route.routeName, route.params, { replace: true })
            }
        });
    }
}
